import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

/** TODO MC-8715 */
export const BrowserTitle = styled(Typography)(({ theme }) => ({
	...theme.typography.body1,
	fontWeight: 600,
	marginBottom: '16px',
	color: theme.palette.primary.dark,
}));

export const LoginBox = styled(Box)(({ theme }) => ({
	display: 'grid',
	gridAutoFlow: 'column',
	gridTemplateColumns: 'max-content',
	alignItems: 'center',
	color: theme.palette.primary.dark,
	marginBottom: 16,

	/** TODO MC-8715 */
	'& > span': {
		...theme.typography.body1,
		fontWeight: 600,
		marginRight: 16,
	},
}));

export const ErrorWrapper = styled('span', {
	shouldForwardProp: (prop) => prop !== 'error',
})<{ error: boolean }>(({ theme, error }) => ({
	display: error ? 'block' : 'none',
	color: theme.palette.error.main,
	...theme.typography.caption /** TODO MC-8715 */,
}));
